import { render, staticRenderFns } from "./DelayedInvoice.vue?vue&type=template&id=5b2f9b5e&scoped=true&"
import script from "./DelayedInvoice.vue?vue&type=script&lang=ts&"
export * from "./DelayedInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./DelayedInvoice.vue?vue&type=style&index=0&id=5b2f9b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f9b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
